import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-金标认证",
  "use": "icon-金标认证-usage",
  "viewBox": "0 0 1228 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1228 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-金标认证\">\r\n\t<defs>\r\n\t\t<style type=\"text/css\">\r\n\t\t</style>\r\n\t</defs>\r\n\t<path d=\"M102.4 230.4L614.4 768 1100.8 204.8 1228.8 332.8 614.4 1024 0 358.4z m51.2-76.8L281.6 0H921.6l128 128L921.6 256l-76.8-76.8H358.4l-76.8 102.4z\" p-id=\"2221\">\r\n\t</path>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol